module.exports = __webpack_public_path__ + "Gotham-Light.5d34ff6511e66ec0e893.eot";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Light.eot
// module id = ../../../../../src/assets/fonts/Gotham-Light.eot
// module chunks = 2